<template>
    <el-pagination 
        :layout="layout ? layout : 'prev, pager, next, total'" 
        :total="total" 
        :page-size="obj[attrSize]" 
        :current-page="obj[attrIndex]" 
        @current-change="handleCurrentChange" 
        @size-change="handleSizeChange"
        :page-sizes="attrSizes"
    >
    </el-pagination>
</template>
<script>
export default {
    name: 'pagenation',
    props: ['obj', 'attrIndex', 'attrSize', 'total', 'layout', 'attrSizes'],
    methods: {
        handleCurrentChange(val) {
            var obj = this.obj;
            var attr = this.attrIndex;
            this.$store.dispatch('updateObject', {
                obj: obj,
                attr: attr,
                val: val
            })
            this.$emit('click', val);
        },
        handleSizeChange(val) {
            var obj = this.obj;
            var attr = this.attrSize;
            this.$store.dispatch('updateObject', {
                obj: obj,
                attr: attr,
                val: val
            })
            this.$emit('click', val);
            console.log(`每页 ${val} 条`);
        },
    }
}
</script>
